<template>
       <div class="item-category" :class="{act : activeIndex == index }" @click="$emit('do-event')">{{ item.text }}</div>
</template>

<script>
export default {
    props:{
        item: {
            type: Object,
            default(){
                return {};
            }
        },
        index: {
            type: Number,
            default: 0
        },
        activeIndex: {
            type: Number,
            default: 0
        }
    },
    setup() {


    },
    methods:{

    }
}
</script>

<style scoped>

</style>
